import {
  ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, Renderer2,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'mcrai-spacer',
  template: ``,
  styles: [`.mcrai-spacer{display:block;height:1px;margin:20px 0}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-spacer]': 'true'
  }
})
export class SpacerComponent implements OnInit {

  @Input('mcrai-spacer') set mcraiSpacer(value: string) {
    this.color = value;
  }

  @Input('color') set color(value: string) {
    this._removeAllColorClasses();

    this._renderer
      .addClass(this._elRef.nativeElement, `mcrai-spacer--${value}`);
  }

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef,
  ) { }

  ngOnInit() { }

  private _removeAllColorClasses(): void {
    const colors = ['primary', 'secondary', 'alternative'];

    colors.forEach(color => {
      this._renderer
        .removeClass(this._elRef.nativeElement, `mcrai-spacer--${color}`);
    });
  }

}
